import { memo, PropsWithChildren } from 'react';
import { DialogTrigger } from 'react-aria-components';

import { Button, Dialog, Flex, Heading, Logo, Modal, ModalOverlay, Text } from '@/components/core';

import { DeleteIcon } from '../icons';

type ConfirmDialogProps = {
  onConfirm?: () => void;
  onCancel?: () => void;
  confirm?: string;
};

const IConfirmDialog = ({ confirm, onConfirm, onCancel, children }: PropsWithChildren<ConfirmDialogProps>) => {
  return (
    <DialogTrigger>
      {children}

      <ModalOverlay>
        <Modal>
          <Dialog className="w-[24rem] p-4 outline-none">
            <Flex col className="gap-md">
              <Flex className="gap-sm items-center">
                <Logo variant="error" size="lg">
                  <DeleteIcon />
                </Logo>
                <Heading size="lg">Are you sure?</Heading>
              </Flex>

              <Text variant="secondary">{confirm ?? 'This action cannot be undone.'}</Text>

              <Flex className="gap-sm justify-end">
                <Button variant="secondary" slot="close" onPress={onCancel}>
                  <Text>Cancel</Text>
                </Button>
                <Button variant="danger" slot="close" onPress={onConfirm}>
                  <Text>Delete</Text>
                </Button>
              </Flex>
            </Flex>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
};

export const ConfirmDialog = memo(IConfirmDialog);
